import { Button } from '../../../../../components/button/button';
import { Page } from '../../../../../components/page/page';
import s from './create-qr.module.css';
import { QrSettings } from './qr-settings/qr-settings';
import { QrServices } from './qr-services/qr-services';
import { useCreateQr } from './use-create-qr';
import { QrLinks } from './qr-links/qr-links';

export const CreateQr = () => {
  const { handleNext, isLoading, id, t } = useCreateQr();

  return (
    <Page className={s.page}>
      <h2 className={s.title}>
        {t(id ? 'Изменить статический QR-код' : 'Создать статический QR-код')}
      </h2>
      <div className={s.container}>
        <div className={s.steps}>
          <QrSettings />
          <QrServices />
          <QrLinks />
        </div>
        <div className={s.controls}>
          <Button variant="secondary" hrefBack disabled={isLoading} data-testid="cancel-qr">
            {t('Назад')}
          </Button>
          <Button
            variant="primary"
            onClick={handleNext}
            disabled={isLoading}
            data-testid="submit-qr"
          >
            {t(id ? 'Изменить' : 'Создать')}
          </Button>
        </div>
      </div>
    </Page>
  );
};
